import { useMemo } from 'react'
import { getClaims } from 'services/Authentication'

const useIsAssistant = (): boolean => {
  return useMemo(() => {
    const claims = getClaims()
    return claims?.role === 'assistant'
  }, [])
}

export default useIsAssistant
